import React from 'react';

import Icon from './Icon';
import { IconProps } from './types';

const DownCaretIcon = (props: IconProps) => <Icon {...props} src={'/icons/dropdown-caret-down.svg'} />;

export default DownCaretIcon;
